const BleachLogger = {
  // Log levels
  ASSERT: 1,
  ERROR: 2,
  WARN: 3,
  INFO: 4,
  DEBUG: 5,
  VERBOSE: 6,

  loggingLevel: 4, // Default: INFO

  // Set/get level
  set level(level) {
    this.loggingLevel = level
  },
  get level() {
    return this.loggingLevel
  },

  // Normal console methods — getters return the native method if level allows
  get assert() {
    return this.loggingLevel >= this.ASSERT ? console.assert : () => {}
  },
  get error() {
    return this.loggingLevel >= this.ERROR ? console.error : () => {}
  },
  get warn() {
    return this.loggingLevel >= this.WARN ? console.warn : () => {}
  },
  get info() {
    return this.loggingLevel >= this.INFO ? console.info : () => {}
  },
  get debug() {
    return this.loggingLevel >= this.DEBUG ? console.debug : () => {}
  },
  get log() {
    return this.loggingLevel >= this.VERBOSE ? console.log : () => {}
  },

  /**
   * system() is a normal method, not a getter returning a wrapper.
   * This preserves exact call site in DevTools even with styling.
   */
  system(...args) {
    if (this.loggingLevel >= this.VERBOSE) {
      // Call console.log directly, passing style, preserving call site
      console.log("%c %s", "background: #222; color: #ddd", ...args)
    }
  }
}

export default BleachLogger
